import React from 'react'

import './pageNotFound.css'

const PageNotFound = () => {
  return (
    <div>PageNotFound</div>
  )
}

export default PageNotFound